import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // user = null   -> en cours de vérification
    // user = false  -> non authentifié
    // user = object -> connecté
    const [user, setUser] = useState(null);

    const refresh = useCallback(async () => {
        if (!getToken()) {
            setUser(false);
            return;
        }
        try {
            const me = await authApi.me();
            setUser(me);
        } catch {
            setToken(null);
            setUser(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(async (email, password) => {
        const data = await authApi.login(email, password);
        setToken(data.token);
        setUser(data.user);
        return data.user;
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setUser(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
